import { FilledCard, Heading2, Stack } from '@phx/design-system';
import { PricingInfo } from '@phx/myphx-lib';
import { useTranslation } from 'react-i18next';

import { GenericSwapPricingDesc } from './GenericSwapPricingDesc';
import { NoPricing } from './NoPricing';
import type { PricingProps } from './shared';

export const PickupPricing = ({ offer, genericSwap }: PricingProps) => {
    const { t } = useTranslation();

    const priceSection =
        offer.__typename === 'CashOffer' ||
        offer.__typename === 'InsuranceOffer' ? (
            <PricingInfo
                option={offer.pricingDetail.option}
                value={offer.pricingDetail.value}
                details={offer.pricingDetail.details ?? ''}
            />
        ) : (
            <NoPricing />
        );

    return (
        <Stack gap="xxs" data-testid="price-quote-card">
            <Stack gap="sm">
                <Heading2>{t('pricing.subHeader')}</Heading2>
                {genericSwap && (
                    <GenericSwapPricingDesc
                        brandName={genericSwap.brandName}
                        genericName={genericSwap.genericName}
                    />
                )}
                <FilledCard color="gray">{priceSection}</FilledCard>
            </Stack>
        </Stack>
    );
};
